// Shared ICD-10 diagnosis-code typeahead. GET /api/Master/DiagnosisCodes?system&searchQuery
// → ConditionCode[] (curl-verified by Andrew 2026-05-19; in production use by the patient-chart
// Problems/Family-History editors). Lives in @/shared so cross-domain consumers (encounter A/P,
// patients chart, billing claims) can share ONE hook without cross-importing each other's
// modules — the consolidation the patients-copy TODO calls for. (patients/billing copies can
// migrate to this later; not done here to keep the slice scoped.)
import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { ConditionCode } from '@/types/patient-chart-api';

const MIN_QUERY_LENGTH = 2;
/** ICD-10 is the default catalog. Future: ICD-11 / SNOMED toggle. */
const DEFAULT_SYSTEM = 'ICD-10';

export function useDiagnosisCodeSearch(
  query: string,
  enabled = true,
  system: string = DEFAULT_SYSTEM,
) {
  const trimmed = query.trim();
  return useQuery({
    queryKey: ['master-diagnosis-codes', system, trimmed],
    queryFn: ({ signal }) => {
      const qs = new URLSearchParams({ system, searchQuery: trimmed });
      return get<ConditionCode[]>(`/api/Master/DiagnosisCodes?${qs.toString()}`, { signal });
    },
    enabled: enabled && trimmed.length >= MIN_QUERY_LENGTH,
    staleTime: 5 * 60 * 1000,
    placeholderData: (prev) => prev,
  });
}
